import { takeLatest, call, put } from "redux-saga/effects";
import {
   ADD_ADMIN_SKILLS,
   ADD_ADMIN_SKILLS_SUCCESS,
   GET_ADMIN_SKILLS, 
   GET_ADMIN_SKILLS_SUCCESS,
   UPDATE_ADMIN_SKILLS,
   UPDATE_ADMIN_SKILLS_SUCCESS,
   DELETE_ADMIN_SKILLS,
   DELETE_ADMIN_SKILLS_SUCCESS,
   } from "../../redux/actions/actionType";
import api from "../../apis/api";

// api functions.
// get all skills.
function* getSkillApi() {
  const response = yield api.dbadminSkills().getAllSkills();
  return response.data;
}
//add skills.
function addAdminSkillApi(formData) {
  // api for add skill.
  api.dbadminSkills().AddEditProjectSkills(formData);
}

function updateSkillApi(formData) {
  // api for update skill.
  api.dbadminSkills().AddEditProjectSkills(formData);
}
function delSkillApi(delId) {
  // api for delete skill
  const response = api.dbadminSkills().DeleteSkill(delId);
  return response;
}
// get all skills.
export function* handleGetSkill() {
  try {
    const response = yield call(getSkillApi);
    yield put({ type: GET_ADMIN_SKILLS_SUCCESS, payload: response });
  } catch (error) {
     
  }
}
// add skills.
export function* handleAddSkills({ payload }) {
  try {
    yield call(addAdminSkillApi, payload);

    yield put({ type: ADD_ADMIN_SKILLS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleUpdateSkills({ payload }) {
  try {
    yield call(updateSkillApi, payload);
    yield put({ type: UPDATE_ADMIN_SKILLS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
export function* handleDelSkills({ payload }) {
  try {
    yield call(delSkillApi, payload);
    yield put({ type: DELETE_ADMIN_SKILLS_SUCCESS, payload: payload });
  } catch (error) {
     
  }
}
// skill watch fucntion.
export function* adminskillWatchFun() {
  yield takeLatest(GET_ADMIN_SKILLS, handleGetSkill);
  yield takeLatest(ADD_ADMIN_SKILLS,handleAddSkills); 
  yield takeLatest(UPDATE_ADMIN_SKILLS, handleUpdateSkills);
  yield takeLatest(DELETE_ADMIN_SKILLS, handleDelSkills);
}
